module.exports = __webpack_public_path__ + "media/images/login-731b5a800f68675dd998973e1fedfb3d.png";